import { IonCol, IonGrid, IonIcon, IonInput, IonRow } from '@ionic/react';
import '@ionic/react/css/ionic-swiper.css';
import { arrowBackOutline, searchSharp } from 'ionicons/icons';
import React from 'react';
import { Link } from 'react-router-dom';
// import ListGrid from '../ListGrid/ListGrid';
import './SearchBar.scss';

export default function SearchBar(props: {
  data: any,
  hasNavigation: boolean,
}) {
  const { data, hasNavigation } = props;

  return (
    <IonGrid className="search-bar-container" style={{ padding: '0px' }}>
      <IonRow style={{ textAlign: 'center' }}>
        {
          hasNavigation && (
            <IonCol size="1" className="navigation-container">
              <Link to="/" style={{ textDecoration: 'none' }}>
                <IonIcon src={arrowBackOutline} className="search-back" />
              </Link>
            </IonCol>
          )
        }
        <IonCol style={{ padding: '0px' }} size={hasNavigation ? '10' : '12'} className="search-value">
          <Link
            style={{ textDecoration: 'none' }}
            to="/search"
          >
            <IonInput
              className="search-input"
              value={data?.name?.replace('<br>', ' ')}
              placeholder="Techniques, Roles, Skills and More"
              data-testid="search-input"
              readonly
            >
              <IonIcon
                icon={searchSharp}
                className="search-icon"
              />
            </IonInput>
          </Link>
        </IonCol>
        {/* {
          hasNavigation && (
            <IonCol size="1" className="navigation-container" style={{ justifyContent: 'end' }}>
              <IonIcon src={helpOutline} className="search-help" />
            </IonCol>
          )
        } */}
      </IonRow>
    </IonGrid>
  );
}
